import { COLOR_BORDER } from "./tokens.ts";

export function ControlGroupSeparator() {
  return (
    <div
      style={{
        width: 24,
        height: 1,
        background: COLOR_BORDER,
        margin: "4px 0",
        flexShrink: 0,
      }}
    />
  );
}
